import { AddImages } from "@coworker/apprestructured/src/task-management/components/AddImages/AddImages";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { Ref, useCallback } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

const NO_NEW_OR_EXISTING_FILES: NewOrExistingFile[] = [];

export type AddImagesCreatorFragmentConfigProps = EmptyObject;

type AddImagesCreatorFragmentProps = {
  configProps: AddImagesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AddImagesCreatorFragment({
  commonProps,
}: AddImagesCreatorFragmentProps) {
  const { blockInput, task, onTaskChange } = commonProps;
  const images = getByPath<NewOrExistingFile[]>(task, "images");
  const handleConfirmClick = useCallback(
    (images: NewOrExistingFile[]) => {
      onTaskChange({ images });
    },
    [onTaskChange]
  );

  return (
    <AddImages
      images={isLoading(images) ? NO_NEW_OR_EXISTING_FILES : images}
      onConfirmClick={handleConfirmClick}
      disabled={blockInput || isLoading(images)}
    />
  );
}

export default AddImagesCreatorFragment;
